<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Partner"
    }
</script>

<style scoped>

</style>